import React from "react";

const Footer = () => {
  return (
    <footer>
      Clone du site "Le Bon Coin" - codé par &nbsp;
      <a href="https://www.linkedin.com/in/julie-lesage-92a09117/"> Julie</a>
    </footer>
  );
};

export default Footer;
